export default "__VITE_PUBLIC_ASSET__893cf2c9__"